
export default function MinusButton() {
    return (
        <i className="pi pi-minus-circle" />
    )
}